var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "d-flex flex-column gr-6" },
    [
      _c(
        "div",
        {
          staticClass: "px-2",
          class: _setup.isMobile ? "text-h6" : "text-h5 text-center",
        },
        [
          _vm._v(
            "\n    " +
              _vm._s(_setup.t("СМИ о ПроДокторов", _setup.options)) +
              "\n  "
          ),
        ]
      ),
      _vm._v(" "),
      _setup.isMobile
        ? _c(_setup.CoreSwiper, {
            scopedSlots: _vm._u(
              [
                {
                  key: "slides",
                  fn: function ({ slideAttrs }) {
                    return _vm._l(_setup.mediaList, function (media, index) {
                      return _c(
                        "div",
                        _vm._b({ key: index }, "div", slideAttrs, false),
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column elevation-1 rounded-sm mx-2",
                            },
                            [
                              _c("div", {
                                staticClass:
                                  "media-list__logo border-b-sm rounded-t-sm",
                                class: media.logoClass,
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex flex-column gr-4 pa-4 text-center",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "text-subtitle-1 text--text",
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(media.title) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "text-body-2 text-secondary--text",
                                    },
                                    [
                                      _vm._v(
                                        "\n              «" +
                                          _vm._s(media.text) +
                                          "...»\n            "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    })
                  },
                },
              ],
              null,
              false,
              1509345133
            ),
          })
        : _c(
            "div",
            { staticClass: "media-list" },
            _vm._l(_setup.mediaList, function (media, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass:
                    "d-flex flex-column hover-animation elevation-1 rounded-sm",
                },
                [
                  _c("div", {
                    staticClass: "media-list__logo border-b-sm rounded-t-sm",
                    class: media.logoClass,
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "d-flex flex-column gr-4 pa-4 text-center" },
                    [
                      _c("div", { staticClass: "text-subtitle-1 text--text" }, [
                        _vm._v(
                          "\n          " + _vm._s(media.title) + "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "text-body-2 text-secondary--text" },
                        [
                          _vm._v(
                            "\n          «" +
                              _vm._s(media.text) +
                              "...»\n        "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }